import { Slot } from '@radix-ui/react-slot'
import { cn } from '@scalis/utils'
import { captionClassName } from './caption.styles'
import { CaptionProps } from './caption.types'

/** @deprecated use typography classes instead, such as
 * `caption-basic`,
 * `caption-emphasis`,
 * `caption-italic`
 */
export const Caption = ({
  asChild,
  underline,
  italic,
  type,
  color,
  center,
  size,
  className,
  ...props
}: CaptionProps) => {
  const Comp = asChild ? Slot : 'span'

  return (
    <Comp
      className={cn(
        captionClassName({
          underline,
          italic,
          type,
          color,
          center,
          size,
        }),
        className,
      )}
      {...props}
    />
  )
}
